import { render } from "./slide.vue?vue&type=template&id=72927589&scoped=true"
import script from "./slide.vue?vue&type=script&lang=js"
export * from "./slide.vue?vue&type=script&lang=js"

import "./slide.vue?vue&type=style&index=0&id=72927589&scoped=true&lang=css"

import exportComponent from "D:\\Users\\User\\Documents\\_PROJECTS\\VUE.JS\\tulmash\\web_widgets\\calc_conveyor\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72927589"]])

export default __exports__